import { styled, Tooltip, tooltipClasses, type TooltipProps } from '@mui/material';
import { GridEditInputCell, type GridRenderEditCellParams } from '@mui/x-data-grid';

export interface TooltipInputCellProps extends GridRenderEditCellParams {
  maxLength?: number;
}

const ErroredTooltip = styled(({ className, ...props }: TooltipProps) => (
  <Tooltip {...props} classes={{ popper: className }} />
))(({ theme }) => ({
  [`& .${tooltipClasses.tooltip}`]: {
    backgroundColor: theme.palette.error.main,
    color: theme.palette.error.contrastText
  }
}));

const TooltipInputCell = (props: TooltipInputCellProps) => {
  return (
    <ErroredTooltip open={!!props.error} title={props.error || ''}>
      <GridEditInputCell
        {...props}
        slotProps={{
          root: { slotProps: { htmlInput: { maxLength: props.maxLength, autoComplete: 'off' } } }
        }}
      />
    </ErroredTooltip>
  );
};

export default TooltipInputCell;
